<template>
  <div class="info">
    <div class="container">
      <p>
        Na tej stronie, w szybki i wygodny sposób, możesz doładować swój przedpłatowy licznik energii elektrycznej.
      </p>
      <div class="btn-wrapper">
        <a href="https://www.poczta-polska.pl/dla-ciebie/oferta/uslugi-finansowe/wplaty/doladowania-energetyczne-on-line/" target="_blank">Dowiedz się więcej</a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Info'
}
</script>

<style lang="scss" src="../assets/scss/info.scss" scoped></style>
